const GA_ID = "G-FCPT6L6H7G";

let started = false;

/**
 * gatsby-plugin-google-gtag injects the tag during initial page load, where
 * 336kb of gtag.js competes with the font, the project images and the app
 * bundle for bandwidth. Loading it at idle instead keeps analytics intact while
 * taking it off the critical path, and visitors who bounce in the first few
 * seconds never pay for it at all.
 */
const startAnalytics = () => {
  if (started) return;
  started = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  // Queued now, flushed by gtag.js once it arrives. This config call is what
  // sends the first page_view.
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
};

export const onClientEntry = () => {
  if (navigator.doNotTrack === "1" || window.doNotTrack === "1") return;

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(startAnalytics, { timeout: 6000 });
  } else {
    window.setTimeout(startAnalytics, 4000);
  }
};

export const onRouteUpdate = ({ prevLocation, location }) => {
  // No prevLocation means the first render, whose page_view the config call
  // above already sent. Counting it here too would double every session.
  if (!prevLocation || typeof window.gtag !== "function") return;

  window.gtag("event", "page_view", {
    page_path: location.pathname + location.search,
  });
};
